import React, { useState } from 'react'
import './Contacts.css'
import emailjs from '@emailjs/browser';
import { useRef } from 'react';
import { themeContext } from '../../Context';
import { useContext } from 'react';
const Contacts = () => {
  const form = useRef();
  const [done,setDone] = useState(false) 
  const [emailSent, setEmailSent] = useState(false);
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_s8gjghl', 'template_so3cbo8', form.current, 'KdHLa4JXPjGmK18o1')
      .then((result) => {
          console.log(result.text);
          setDone(true);
      }, (error) => {
          console.log(error.text);
      });

     // const [emailSent, setEmailSent] = useState(false);

    emailjs.sendForm('service_s8gjghl', 'template_ehn3iwl', e.target, 'KdHLa4JXPjGmK18o1')
      .then((result) => {
        console.log(result.text);
        setEmailSent(true);
      }, (error) => {
        console.log(error.text);
      });

  };
  // const [emailSent, setEmailSent] = useState(false);

  // function sendEmail(e) {
  //   e.preventDefault();

  //   emailjs.sendForm('service_s8gjghl', 'template_ehn3iwl', e.target, 'KdHLa4JXPjGmK18o1')
  //     .then((result) => {
  //       console.log(result.text);
  //       setEmailSent(true);
  //     }, (error) => {
  //       console.log(error.text);
  //     });
  // }
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="contact-form" id="Contacts">
        <div className="w-left">
            <div className="awesome">
                <span style={{color:darkMode? 'white': ''}}>Get in touch </span>
                <span>Contact me </span>
                <div className="blur s-blur1" style={{background:"#ABF1FF94"}}></div>
            </div>
        </div>
        <div className="c-right">
          <form ref={form} onSubmit={sendEmail}>
            <input type="text"name="user_name" className="user"placeholder="Name"  required />
            <input type="email" name="user_email" className="user"placeholder="Email" required />
            <textarea name="message" className="user" id=""  placeholder='Message' required></textarea>
            <input type="submit" className='button' value='Send' />
            <span>{done && "!!! Thanks for contacting me !!!"}</span>
            <div 
              className="blur c-blur1" 
              style={{background:"var(--purple)"}}>
            </div>

          </form>
        </div>
    </div>
  )
}

export default Contacts